export default __webpack_public_path__ + "static/media/what-to-hide-on-collapse.7fc2d982.png";